enum NetlossCategory {
  UNDER_500 = 1,
  BETWEEN_500_AND_1000 = 2,
  BETWEEN_1001_AND_2500 = 3,
  OVER_2500 = 4,
}

export default NetlossCategory
